import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FileText, PhoneOff, ArrowUpRight, MessageSquareText } from "lucide-react";
import { track } from "../lib/analytics";

// Entry router: visitors arrive at different stages — letter in hand, verbal-only
// denial, appeal already denied, or no documents at all. Each card routes to the
// flow built for that stage. The hero CTA above remains the shortcut for stage A.
const STAGES = [
  { key: "letter", to: "/check", Icon: FileText, testId: "stage-letter" },
  { key: "no-letter", to: "/start/no-letter", Icon: PhoneOff, testId: "stage-no-letter" },
  { key: "appeal-denied", to: "/start/appeal-denied", Icon: ArrowUpRight, testId: "stage-appeal-denied" },
  { key: "no-docs", to: "/start/no-docs", Icon: MessageSquareText, testId: "stage-no-docs" },
];

export function StagePicker() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const pick = (stage, to) => {
    track("stage_selected", { stage });
    navigate(to);
  };
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="stage-picker">
      <h2 className="text-lg font-bold text-slate-900 mb-4" data-testid="stage-picker-title">{t("landing.stagesTitle")}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {STAGES.map((s) => (
          <button key={s.key} type="button" onClick={() => pick(s.key, s.to)}
            className="text-left bg-white border border-slate-200 rounded-2xl p-5 hover:border-emerald-400 hover:shadow-md transition-shadow group"
            data-testid={s.testId}>
            <s.Icon size={20} className="text-emerald-600 mb-3" />
            <span className="font-semibold text-sm text-slate-900 block leading-snug">{t(`landing.stage_${s.key}`)}</span>
            <span className="text-xs text-slate-500 block mt-1.5 leading-relaxed">{t(`landing.stage_${s.key}_d`)}</span>
          </button>
        ))}
      </div>
      <div className="mt-4 bg-slate-50 border border-slate-200 rounded-2xl px-5 py-4 flex items-center justify-between gap-4 flex-wrap" data-testid="stage-guide-row">
        <span className="text-sm text-slate-600">{t("landing.stageGuideRow")}</span>
        <Link to="/guide" className="text-sm font-semibold text-emerald-700 hover:text-emerald-800 inline-flex items-center gap-1.5" data-testid="guide-entry-link">
          {t("landing.stageGuideLink")} <ArrowUpRight size={15} />
        </Link>
      </div>
    </section>
  );
}
